import { timelineEntries } from '@/mocks/home';
import Reveal from '@/components/feature/Reveal';
import SectionHeading from '@/pages/home/components/SectionHeading';

const tagStyles: Record<string, string> = {
  实锤: 'bg-primary-100 text-primary-800',
  更新: 'bg-secondary-100 text-secondary-900',
  归档: 'bg-background-200 text-foreground-800',
  线索: 'bg-accent-100 text-accent-900',
  深扒: 'bg-primary-100 text-primary-800',
  合集: 'bg-secondary-100 text-secondary-900',
};

export default function TimelineSection() {
  return (
    <section id="timeline" className="border-b border-background-200 bg-background-50 py-20 md:py-28">
      <div className="w-full px-4 md:px-6">
        <Reveal>
          <SectionHeading
            index="03"
            eyebrow="Update Timeline"
            title="更新时间线：每一次改动都留痕"
            desc="条目不是一次写完的。这里记录新增、修订与归档的完整过程，方便你判断某条黑料反差实锤是刚刚补充，还是已经过多次校对。"
          />
        </Reveal>

        <div className="relative mt-14 pl-6 md:pl-10">
          <span className="absolute bottom-2 left-0 top-2 w-px bg-background-300" />

          <div className="flex flex-col gap-12">
            {timelineEntries.map((entry, index) => (
              <Reveal key={entry.title} delay={index * 80}>
                <article className="relative">
                  <span className="absolute -left-6 top-1.5 h-3 w-3 -translate-x-1/2 rounded-full bg-primary-500 ring-4 ring-background-50 md:-left-10" />

                  <div className="flex flex-wrap items-center gap-3">
                    <span className="font-label text-xs tracking-wider text-foreground-500">
                      {entry.date} · {entry.time}
                    </span>
                    <span
                      className={`rounded-full px-2.5 py-1 text-[11px] ${
                        tagStyles[entry.tag] ?? 'bg-background-200 text-foreground-800'
                      }`}
                    >
                      {entry.tag}
                    </span>
                  </div>

                  <h3 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-950 md:text-xl">
                    {entry.title}
                  </h3>
                  <p className="mt-2.5 max-w-2xl text-sm leading-relaxed text-foreground-600">{entry.desc}</p>
                </article>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={120}>
          <a
            href="#keywords"
            className="mt-14 inline-flex h-10 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-5 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            <i className="ri-history-line" />
            查看更早的归档日志
          </a>
        </Reveal>
      </div>
    </section>
  );
}